import Story from "./story/thumbnail.es6";
import StoryNavs from "./story/navs.es6";

const story = new Story();
const storyNavs = new StoryNavs();
